module.exports = __webpack_public_path__ + "static/media/doorToDoorIcon.450c5f8e.svg";